import React from 'react'
import styles from './custom_primary_button.module.css'

export default function CustomPrimaryButton(props){
    return(
        <button onClick={props.doClick} className={styles.btn_selectFile}>{props.text}</button>
    )
}